import { useTranslation } from 'libs/i18n'
import { useNavigate } from 'libs/router'
import { routes } from 'config/routes'
import type { Option } from 'shared/components/ContextMenu/types'

type UseContextMenuOptionsProps = {
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({ onDelete }: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return [
		{
			label: t('Edit'),
			action: (id: number) => navigate(routes.areaEdit(String(id)))
		},
		{
			label: t('History'),
			action: (id: number) => navigate(routes.areaHistory(String(id)))
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
